import GoodsLibrary from "./-goodsLibrary";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/goods/goodsLibrary")({
  staticData: {
    menuLabel: "商品库",
    showInMenu: true,
    menuGroup: "/goods",
    menuOrder: 2,
  },
  component: GoodsLibrary,
});
